import { AxiosPromise } from 'axios';
import { IrClaimDTO } from '../store/irClaimSlice';
import api, { getPaginatedCountFromResponse } from './api';

export interface NotifyItBlockDomainPayload {
  claimNumber: string;
  claimTitle: string;
  claimStatus: string;
  lossDate: string | null;
  incidentType: string | null;
  origamiStatus: string | null;
  memberName: string;
  memberType: string | null;
  memberNumber: string | null;
  domains: string;
  requestedBy: { firstName: string; lastName: string; email: string };
}


export function getAllClaims(arg: any = null) {
  return new Promise<{ data: any; count: number | null }>((resolve, reject) => {
    try {
      api.get('/ir-claim', {
        params: arg,
      })
        .then((response: any) => {
          resolve({ data: response.data, count: getPaginatedCountFromResponse(response) });
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

// Commented notifyAtom API — Atom Group engagement terminated (28/07/2026)
// export function notifyAtom(claimId: number) {
//   return new Promise<AxiosPromise>((resolve, reject) => {
//     try {
//       api.post(`/ir-claim/notify/${claimId}`)
//         .then((response: any) => {
//           resolve(response);
//         })
//         .catch((e: Error) => {
//           reject(e);
//         });
//     } catch (e) {
//       reject(e);
//     }
//   });
// }

export function getOneClaim(claimId: number) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.get(`/ir-claim/${claimId}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function getOneClaimContacts(claimId: number) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.get(`/ir-claim/contacts/${claimId}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function getOneClaimTechnology(claimId: number) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.get(`/ir-claim/technology/${claimId}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
export function getOneClaimFiles(claimId: number) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.get(`/ir-claim/files/${claimId}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function getOneClaimUpdates(claimId: number) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.get(`/ir-claim/updates/${claimId}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function getOneClaimPrivateComments(claimId: number) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.get(`/ir-claim/private-comments/${claimId}`)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}

export function updateOneClaim(
  claimId: number, updateBody: Partial<IrClaimDTO>,
) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .patch(`/ir-claim/${claimId}`, updateBody)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}



export function resyncClaim() {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api
        .post('/ir-claim/sync')
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}


export function notifyItBlockDomain(claimId: number, payload: NotifyItBlockDomainPayload) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.post(`/ir-claim/notify-it-block-domain/${claimId}`, payload)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
